import React, {
  createContext,
  Dispatch,
  FC,
  PropsWithChildren,
  SetStateAction,
  useContext,
  useState
} from 'react';

const SearchStateContext = createContext(false);

const SearchSetStateContext = createContext<Dispatch<SetStateAction<boolean>>>(
  () => void 0
);

export const SearchStateProvider: FC<PropsWithChildren> = (props) => {
  const { children } = props;
  const [open, setOpen] = useState(false);

  return (
    <SearchSetStateContext.Provider value={() => setOpen((prev) => !prev)}>
      <SearchStateContext.Provider value={open}>
        {children}
      </SearchStateContext.Provider>
    </SearchSetStateContext.Provider>
  );
};

export const useSearchState = () => useContext(SearchStateContext);

export const useSearchSetState = () => useContext(SearchSetStateContext);
